<div class="h-full flex flex-col">
  <app-header></app-header>
  <div class="grow overflow-y-auto flex flex-col items-center">
    <main
      class="grow w-full flex flex-col gap-16 md:gap-28 px-5 md:w-4/5 lg:w-3/4"
    >
      <!-- Sección de la cabecera. -->
      <section class="mt-16 md:mt-28 flex flex-col gap-4">
        <h1 class="text-4xl md:text-5xl font-medium">Productos</h1>
      </section>

      <!-- Sección de activaciones. -->
      <section class="flex flex-col md:flex-row md:flex-wrap gap-10">
        @if (loading) {
        <!-- Contenido de carga. -->
        <div
          class="w-full md:w-[280px] h-[300px] rounded-3xl bg-gray-200 cursor-wait animate-pulse"
        ></div>
        <div
          class="w-full md:w-[280px] h-[300px] rounded-3xl bg-gray-200 cursor-wait animate-pulse"
        ></div>
        <div
          class="w-full md:w-[280px] h-[300px] rounded-3xl bg-gray-200 cursor-wait animate-pulse"
        ></div>
        <div
          class="w-full md:w-[280px] h-[300px] rounded-3xl bg-gray-200 cursor-wait animate-pulse"
        ></div>
        } @else { @if (products.length) { @for (product of products; track
        $index) {
        <!-- Products. -->
        <button
          type="button"
          aria-hidden="false"
          [attr.aria-label]="'Activación ' + product.name"
          routerLink="/activations/{{ product.id }}"
          class="max-w-full md:w-[280px] h-[300px] rounded-3xl flex flex-col gap-10 items-center justify-center border border-gray-300 hover:border-gray-500 cursor-pointer p-5"
        >
          @if(product.image) {
          <img
            [src]="product.image"
            [alt]="product.name"
            class="w-[150px] max-w-full"
          />
          }
          <div class="w-full flex flex-col items-center">
            <h2 class="text-xl font-medium truncate w-full">
              {{ product.name }}
            </h2>
            @if (product.description) {
            <p class="truncate w-full">
              {{ product.description }}
            </p>
            }
          </div>
        </button>
        } } @else {
        <div class="text-gray-500">No hay productos disponibles</div>
        } }
      </section>
    </main>

    <!-- Sección del pie de página. -->
    <app-footer></app-footer>
  </div>
</div>
